import { jsxs, jsx } from "react/jsx-runtime";
import classNames from "classnames";
import "./theme/grid.js";
import "./hooks/useBreakpoint.js";
import "react";
import { AnalyticsId, FormOnColor, IconSize } from "./constants.js";
import { getColor } from "./theme/currys/color.js";
import { I as Icon } from "./Icon.js";
import Attachment from "./components/Icons/Attachment.js";
import Change from "./components/Icons/Change.js";
import Group from "./components/Icons/Group.js";
import NoAccess from "./components/Icons/NoAccess.js";
import styles from "./components/StatusDot/styles.module.scss";
var StatusDotOnColor = ((StatusDotOnColor2) => {
  StatusDotOnColor2[StatusDotOnColor2["onwhite"] = FormOnColor.onwhite] = "onwhite";
  StatusDotOnColor2[StatusDotOnColor2["ondark"] = FormOnColor.ondark] = "ondark";
  return StatusDotOnColor2;
})(StatusDotOnColor || {});
var StatusDotVariant = /* @__PURE__ */ ((StatusDotVariant2) => {
  StatusDotVariant2["info"] = "info";
  StatusDotVariant2["warning"] = "warning";
  StatusDotVariant2["alert"] = "alert";
  StatusDotVariant2["cancelled"] = "cancelled";
  StatusDotVariant2["active"] = "active";
  StatusDotVariant2["transparent"] = "transparent";
  StatusDotVariant2["recurring"] = "recurring";
  StatusDotVariant2["group"] = "group";
  StatusDotVariant2["noaccess"] = "noaccess";
  StatusDotVariant2["attachment"] = "attachment";
  return StatusDotVariant2;
})(StatusDotVariant || {});
const StatusDotIcon = ({ onColor, variant }) => {
  const color = onColor === StatusDotOnColor.ondark ? getColor("white") : getColor("black");
  const iconProps = { color, size: IconSize.XXSmall, onColor };
  if (variant === "recurring") {
    return /* @__PURE__ */ jsx(Icon, { ...iconProps, svgIcon: Change });
  } else if (variant === "group") {
    return /* @__PURE__ */ jsx(Icon, { ...iconProps, svgIcon: Group });
  } else if (variant === "noaccess") {
    return /* @__PURE__ */ jsx(Icon, { ...iconProps, svgIcon: NoAccess, color: getColor("cherry", 600) });
  } else if (variant === "attachment") {
    return /* @__PURE__ */ jsx(Icon, { ...iconProps, svgIcon: Attachment });
  }
  return null;
};
const StatusDot = (props) => {
  const { id, onColor = StatusDotOnColor.onwhite, variant = "info", text, className, testId } = props;
  const hasIcon = variant === "recurring" || variant === "group" || variant === "noaccess" || variant === "attachment";
  const isCancelled = variant === "cancelled";
  const statusDotClasses = classNames(styles["statusdot"], isCancelled && styles["statusdot--cancelled"], className);
  const dotClasses = classNames(styles["statusdot__dot"], {
    ...hasIcon ? {} : { [styles[`statusdot__dot--${variant}`]]: true },
    [styles["statusdot__dot--on-dark"]]: onColor === StatusDotOnColor.ondark
  });
  const labelClasses = classNames(onColor === StatusDotOnColor.ondark && styles["statusdot__label--on-dark"]);
  return /* @__PURE__ */ jsxs("span", { id, className: statusDotClasses, "data-testid": testId, "data-analyticsid": AnalyticsId.StatusDot, children: [
    /* @__PURE__ */ jsx("span", { className: dotClasses, "data-testid": testId + "-dot", children: /* @__PURE__ */ jsx(StatusDotIcon, { onColor, variant }) }),
    /* @__PURE__ */ jsx("span", { className: labelClasses, children: text })
  ] });
};
export {
  StatusDot as S,
  StatusDotOnColor as a,
  StatusDotVariant as b
};
//# sourceMappingURL=StatusDot.js.map
